export default "__VITE_ASSET__53f3a7e0__"